import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailInput", "submitButton", "form", "successMessage"]

  async send(event) {
    event.preventDefault()
    const email = this.emailInputTarget.value.trim()

    if (!email) {
      this.emailInputTarget.focus()
      return
    }

    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.textContent = "Sending..."

    try {
      const response = await fetch("/magic_links", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ email })
      })

      if (response.ok) {
        this.formTarget.classList.add("hidden")
        this.successMessageTarget.classList.remove("hidden")
      }
    } catch (error) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.textContent = "Send Magic Link"
    }
  }
}
